import actionTypes from './actionTypes';
import update from 'immutability-helper';

export const initialState = {
  numbers: {
    peopleCount: 0,
    initialPeopleCount: 0,
    interactionCount: 0,
    initialInteractionCount: 0,
    peoplePerSecond: 0,
    interactionsPerSecond: 0,
  },
};

export default function (state = initialState, action) {
  switch(action.type) {
    case actionTypes.FETCH_HOME_NUMBERS_SUCCESS:
      return {
        ...state,
        numbers: action.numbers,
      };
    case actionTypes.RECALCULATE_HOME_NUMBERS_SUCCESS:
      return update(state, {
        numbers: {
          peopleCount: { $set: action.peopleCount },
          interactionCount: { $set: action.interactionCount },
        },
      });
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/home/reducer.js